import React from "react";

import ReactTable from "react-table";
import 'react-table/react-table.css'
import {connect} from "react-redux";
import {fetchDeposits, fetchDeposits2} from "../../actions/depositActions";
import Moment from "react-moment";
import {push} from "connected-react-router";

class DepositTest extends React.Component {
  constructor(){
    super();
    this.fetchData = this.fetchData.bind(this);
  }

  fetchData(state, instance) {
    this.props.fetchDeposits(
      state.pageSize,
      state.page,
      state.sorted,
      state.filtered)
    console.log(state)
  }

  render() {
    const cols = [
      {
        Header: "Id",
        accessor: "_id"
      },
      {
        Header: "Time",
        accessor: "timestamp",
        Cell: row => (
          <span>
            <Moment fromNow>{row.value}</Moment>
          </span>
        )
      },
      {
        Header: "Name",
        accessor: "name"
      },
      {
        Header: "File",
        accessor: "file"
      },
      {
        Header: "Status",
        accessor: "status",
        maxWidth: 200,
        Cell: row => (
          <span>
            <span style={{
              color: row.value === 'failed' ? '#ff2e00'
                : row.value === 'warning' ? '#ffbf00'
                  : '#57d500',
              transition: 'all .3s ease'
            }}>
              &#x25cf;
            </span> {row.value}
          </span>
        )
      }
    ]
    return <ReactTable manual columns={cols} data={this.props.deposits} onFetchData={this.fetchData}
                       sortable filterable defaultPageSize={10} pages={this.props.pages} noDataText="No deposits found"
                       getTrProps={(state, rowInfo, column, instance) => ({
                         onClick: e => this.props.gotoDeposit(rowInfo.original._id)
                       })}
                       className="-striped -highlight" loading={this.props.fetching}
    />
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchDeposits: (a,b,c,d) => dispatch(fetchDeposits2(a,b,c,d)),
  gotoDeposit: (a) => dispatch(push(`/deposits/${a}/`))
})

const mapStateToProps = (state) => ({
  deposits: state.deposit.deposits,
  pages: state.deposit.pages,
  fetching: state.deposit.fetching,
  error: state.deposit.error,
})

export default connect(mapStateToProps, mapDispatchToProps)(DepositTest)


// WEBPACK FOOTER //
// ./src/components/Deposits/DepositTest.js